export const paymentSystems = [
  {
    id: 1,
    name: 'Visa/Mastercard',
    logo: 'https://public.readdy.ai/ai/img_res/00d00559574938df81943d37b0d318d5.jpg',
    rating: 4.8,
    minDeposit: '100₽',
    maxWithdrawal: '500000₽',
    withdrawalTime: '1-3 дня',
    commission: '0%',
    pros: ['Привычный метод', 'Высокие лимиты', 'Широкое распространение'],
    cons: ['Долгий вывод', 'Возможны отказы банка']
  },
  {
    id: 2,
    name: 'Криптовалюты',
    logo: 'https://readdy.ai/api/search-image?query=bitcoin%20ethereum%20cryptocurrency%20logos%20digital%20money%20icons%20dark%20background%20modern%20crypto%20design&width=120&height=80&seq=crypto-002&orientation=landscape',
    rating: 4.9,
    minDeposit: '500₽',
    maxWithdrawal: 'Без лимита',
    withdrawalTime: '15-60 минут',
    commission: '0-1%',
    pros: ['Мгновенный вывод', 'Анонимность', 'Без лимитов', 'Низкие комиссии'],
    cons: ['Волатильность курса', 'Нужен криптокошелек']
  },
  {
    id: 3,
    name: 'Электронные кошельки',
    logo: 'https://readdy.ai/api/search-image?query=qiwi%20yoomoney%20webmoney%20electronic%20wallet%20logos%20payment%20icons%20dark%20background%20modern%20design&width=120&height=80&seq=ewallet-003&orientation=landscape',
    rating: 4.7,
    minDeposit: '50₽',
    maxWithdrawal: '300000₽',
    withdrawalTime: '1-24 часа',
    commission: '0-2%',
    pros: ['Быстрый вывод', 'Удобство', 'Низкие лимиты входа'],
    cons: ['Комиссии на некоторых площадках', 'Лимиты на вывод']
  },
  {
    id: 4,
    name: 'Банковский перевод',
    logo: 'https://readdy.ai/api/search-image?query=bank%20transfer%20icon%20banking%20logo%20dark%20background%20financial%20symbol%20modern%20design&width=120&height=80&seq=bank-004&orientation=landscape',
    rating: 4.5,
    minDeposit: '1000₽',
    maxWithdrawal: '1000000₽',
    withdrawalTime: '3-7 дней',
    commission: '0-3%',
    pros: ['Очень высокие лимиты', 'Надежность', 'Официальность'],
    cons: ['Долгий вывод', 'Высокий минимальный депозит', 'Возможны комиссии']
  },
  {
    id: 5,
    name: 'Мобильные платежи',
    logo: 'https://readdy.ai/api/search-image?query=mobile%20payment%20icons%20smartphone%20money%20transfer%20logos%20dark%20background%20modern%20digital%20design&width=120&height=80&seq=mobile-005&orientation=landscape',
    rating: 4.6,
    minDeposit: '50₽',
    maxWithdrawal: '100000₽',
    withdrawalTime: '1-2 дня',
    commission: '0-5%',
    pros: ['Быстрый депозит', 'Удобство', 'Доступность'],
    cons: ['Высокие комиссии', 'Ограниченные лимиты', 'Не везде доступен вывод']
  }
];